import React, { useState, useEffect, useRef } from "react";
// React Bootstrap
import { Container, Row, Col } from "react-bootstrap";
// Spinner
import CustomSpinner from "../generic/CustomSpinner";
// Styled Components
import styled from "styled-components";
// Custom Hooks
import useObserver from "../hooks/UseObserver";
import { useIsMount } from "../hooks/UseIsMount";
import { Link } from "react-router-dom";
// Jquery
import $ from "jquery";
import { Image } from "react-bootstrap";

import { useHistory } from "react-router-dom";

const ItemsCardsContainer = styled.div`
  max-height: 800px; // 335px para mobil
  padding: 5px;
  overflow-x: auto;
`;

// ***GenericExplorer***
// Componente para generar exploradores generícos que maneja el observador y va pidiendo mas elementos.
// url        => URL para pedir items
// ItemCard   => Componente que será la carta de los elementos que se muestran en el explorador
// children   => Filtros del explorador
// addCard    => Contiene el nombre de los elementos a mostrar si lo pasamos indicamos que se pueden añadir items de este tipo
// reset      => Para resetear el componente
const GenericExplorer = ({ url, ItemCard, ItemAddCard, addCard = false, children, reset, onClick = () => { }, apagadoExploraNuevaPestaña = false, provinciaLogueado, ...props }) => {
  const isMount = useIsMount();
  const scrollingDiv = useRef(null);

  const [items, setItems] = useState([]);
  const [totalItems, setTotalItems] = useState(0);
  const [page, setPage] = useState(1);
  const [lastPageReached, setLastPageReached] = useState(false);
  const [reload, setReload] = useState(false);
  const [resetChild, setResetChild] = useState(false); // Para resetear el componente desde el hijo

  // Variable para el spinner
  const [loading, setLoading] = useState(false);

  //para poner el botoncico en la esquina de la tarjeta
  let history = useHistory();

  const expresiones = [
    /\/laicos/i,                                //expresión de misiones /laicos
    /\/hermanas/i,                              //expresión de misiones /heramnas
    /\/provincias\/[\d]{1,3}\/mision/i,         //expresión de misiones /provincias/000/mision
    /\/provincias\/[\d]{1,3}\/comunidades/i,    //expresión de misiones /provincias/000/comunidades
    /\/provincias\/[\d]{1,3}\/gruposTrabajo/i,  //expresión de misiones /provincias/000/gruposTrabajo
    /\/provincias/i,                            //expresión de misiones /provincias
  ]
  const expresionesRef = [
    {
      tipo: 'laicos',
      nivel: 8,
    },
    {
      tipo: 'hermanas',
      nivel: 9,
    },
    {
      tipo: 'mision',
      nivel: 8,
    },
    {
      tipo: 'comunidades',
      nivel: 8,
    },
    {
      tipo: 'gruposTrabajo',
      nivel: 8,
    },
    {
      tipo: 'provincias',
      nivel: 8,
    },
  ]

  useEffect(() => {
    if (!isMount) {
      setPage(1);
      setReload(!reload);
    }
    scrollingDiv.current.scrollTop = 0;
  }, [reset, url, resetChild]);

  useEffect(() => {
    requestItems();
  }, [reload]);

  const requestItems = (addToExisting = false) => {
    setPage(page + 1);
    setLoading(true);
    let settings = {
      url: `${process.env.REACT_APP_API_URL}${url}&page=${page}`,
      method: "GET",
      timeout: 0,
      xhrFields: {
        withCredentials: true,
      },
    };
    $.ajax(settings).done((response) => {
      // console.log(response);
      if (response.totalPages <= page) {
        setLastPageReached(true);
      } else {
        setLastPageReached(false);
      }
      setTotalItems(response.totalItems);
      addToExisting ? addItems(response.items) : setItems([...response.items]);
      setLoading(false);
    });
    // .fail(ErrorHandling);
  };

  const loadMore = () => {
    if (!lastPageReached && !loading) {
      requestItems(true);
    }
  };

  const addItems = (newItems) => {
    setItems([...items, ...newItems]);
  };

  // Observador
  const target = useRef(null);

  useObserver(
    loadMore,
    {
      root: scrollingDiv.current,
      rootMargin: "0px",
      threshold: 1,
    },
    target,
    items
  );

  const validaAbrePestana = (nivelLogueado = -1, provinciaLogueado = -1, provinciaHermana = -1, provinciaLaico = -1, apagadoNuevaPestana,) => {
    const indice = expresiones.indexOf(expresiones.find(element => element.test(history.location.pathname)));
    let retorno = false;
    //las condiciones son 1. que sea mayor que 9 & 2. que no esté apagada la nueva pestaña & || que sea nivel 9 y que la provincia sea la misma
    if (expresionesRef[indice]?.tipo === 'hermana' && !apagadoNuevaPestana) {
      //console.log('11111')
      if (nivelLogueado > expresionesRef[indice]?.nivel) {
        retorno = true;
      } else if (nivelLogueado === expresionesRef[indice]?.nivel && provinciaLogueado === provinciaHermana) {
        retorno = true;
      }
    } else if (expresionesRef[indice]?.tipo === 'laico' && !apagadoNuevaPestana) {
      //console.log('22222')
      if (nivelLogueado > expresionesRef[indice]?.nivel) {
        retorno = true;
      } else if (nivelLogueado === expresionesRef[indice]?.nivel && provinciaLogueado === provinciaLaico) {
        retorno = true;
      }
    } else if (expresionesRef[indice]?.tipo === 'comunidades' && !apagadoNuevaPestana) {
      if (nivelLogueado > expresionesRef[indice]?.nivel) {
        //console.log('33333')
        retorno = true;
      }
    } else if (expresionesRef[indice]?.tipo === 'mision' && !apagadoNuevaPestana) {
      if (nivelLogueado > expresionesRef[indice]?.nivel) {
      //console.log('44444')
      retorno = true;
      }
    } else if (expresionesRef[indice]?.tipo === 'gruposTrabajo' && !apagadoNuevaPestana) {
      if (nivelLogueado > expresionesRef[indice]?.nivel) {
      //console.log('55555')
      retorno = true;
      }
    } else if (nivelLogueado >= expresionesRef[indice]?.nivel && !apagadoNuevaPestana) {
      //console.log('66666')
      retorno = true;
    }
    //console.log(expresionesRef[indice].nivel + '      ' + nivelLogueado)
    return retorno;
    //expresionesRef[expresiones.indexOf(expresiones.find(element => element.test(history.location.pathname)))];
  }

  return (
    <div {...props} style={{ position: "relative" }}>
      <CustomSpinner animation={"border"} loading={loading} />
      <Container className={"p-1 " + props.className} fluid>
        <Row>
          <Col sm="6" md="8" lg="9" xl="10">
            {children}
          </Col>
          <Col sm="6" md="4" lg="3" xl="2" className={"m-auto"}>
            <div style={{ width: "200px" }}>{`Mostrando ${items.length} de ${totalItems}`}</div>
          </Col>
        </Row>
        <ItemsCardsContainer ref={scrollingDiv} fluid>

          <Row noGutters className={"justify-content-center"}>
            {ItemAddCard && <ItemAddCard className={"m-2"} />}
            {items.length === 0 && !ItemAddCard ? (
              <div className="p-2">{"No hay elementos que mostrar"}</div>
            ) : (
              // TODO
              items.map((item, index) => {
                return (
                  <>
                    <Col className={"m-2"} key={item.id} xs={"auto"}>
                      <ItemCard
                        content={item}
                        // Pasamos el reload al hijo por si queremos actualizar el padre cuando borramos una tarjeta con una función debemos actualizar el padre
                        setReload={setResetChild}
                        reload={resetChild}
                        provinciaLogueado={provinciaLogueado}
                        {...props}
                      />

                    </Col>
                    {// comentado 112022 para poner pestañas nuevas en todas las ventanicas
                      /*
                      item.type && item.type === 'Monja' && !apagadoExploraNuevaPestaña && ((props.userLevel > 9) ||
                        (props.userLevel === 9 && item.sister?.destinations[0]?.provinceId === provinciaLogueado.id)) &&
                      <Col className={"mr-2"} key={item.id + '-'} xs={"auto"} style={{ marginLeft: "-36px", marginTop: "12px" }}>
                        <Link to={"/hermanas/" + item.id} target={"_blank"}>
                          <Image title="Explora en otra pestaña" style={{ cursor: "pointer" }} src={`/icons/icon-arrow.svg`} />
                        </Link>
                      </Col>
                      */
                    }

                    {validaAbrePestana(props.userLevel, provinciaLogueado?.id, item.sister?.destinations[0]?.provinceId, item.destinationLaicos ? item.destinationLaicos[0]?.provinceId : undefined, apagadoExploraNuevaPestaña) &&

                      <Col className={"mr-2"} key={item.id + '-'} xs={"auto"} style={{ marginLeft: "-36px", marginTop: "12px" }}>
                        <Link to={history.location.pathname + '/' + item.id} target={"_blank"}>
                          <Image title="Explora en otra pestaña" style={{ cursor: "pointer" }} src={`/icons/icon-arrow.svg`} />
                        </Link>
                      </Col>
                    }
                  </>
                );
              })
            )}
          </Row>

          <Row noGutters>
            <p ref={target} id="observableHelper"></p>
          </Row>
        </ItemsCardsContainer>
      </Container>
    </div>
  );
};

export default GenericExplorer;
